import React from 'react';
import styles from './styles.module.scss';

/**
 * ModalHeader component renders a header for a modal dialog.
 * @param {object} props - The component props.
 * @param {() => void} props.onClose - Event for when the close button is clicked.
 */
export function ModalHeader({ onClose }) {
  return (
    <div className={styles.modalHeader}>
      <div className={styles.placeholder} />
      <div className={styles.logo}>Logo Asset goes here</div>
      <button type="button" className="close-button" aria-label="Close dialog" onClick={onClose}>
        &times;
      </button>
    </div>
  );
}
